<script setup lang="ts">
import { routerBreadcrumbTitle } from '@/router';
import { RouterLink } from 'vue-router';
</script>
<template>
    <ktg-breadcrumbs v-if="$route.meta?.hideBreadcrumb !== true">
        <ktg-breadcrumbs-item href="https://www.tg.ch"> Kanton Thurgau </ktg-breadcrumbs-item>
        <RouterLink custom v-slot="{ href, navigate }" :to="{ name: 'home' }">
            <ktg-breadcrumbs-item :href="href" @click.prevent="navigate()"> ePlan </ktg-breadcrumbs-item>
        </RouterLink>
        <RouterLink
            v-for="item in $route.matched.filter((r) => r.meta?.skipBreadcrumb !== true)"
            :key="item.path || item.name || Math.random() * 100000000"
            :to="item.meta?.breadcrumbTo || item"
            custom
            v-slot="{ href, navigate }"
        >
            <ktg-breadcrumbs-item :href="href" @click.prevent="navigate()">
                {{ routerBreadcrumbTitle(item) }}
            </ktg-breadcrumbs-item>
        </RouterLink>
    </ktg-breadcrumbs>
</template>
